import { SbPlayer } from 'components/app/storyboard/sb-player/sb-player';
import { EditorStats } from 'components/app/editor/editor-stats/editor-stats';
import { EditorActions } from 'components/app/editor/editor-actions/editor-actions';

import styles from './_app-layout.module.scss';

export const AppLayoutSb = () => {
  return (
    <div className={styles.Storyboard}>
      <SbPlayer />
      <div className={styles.Storyboard__stats}>
        <EditorStats itemsName="clips" />
      </div>
      <EditorActions />
    </div>
  );
};
